export default __webpack_public_path__ + "static/media/header-onboarding-4.00baef17.gif";